var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-row',[(!_vm.isPayKan)?_c('indexs'):_vm._e(),(_vm.isPayKan)?_c('paykanban'):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }